'use strict';

/**
 * @typedef JobListController
 * @property { string } jobFilter
 * @property { (function(Job)) } arrivedJob
 * @property { (function(Job): boolean) } canArrive
 * @property { (function(Job): boolean) } canUpdateStatus
 * @property { function(string): string} getDirectionsUrl
 */

/**
 * @param $scope
 * @param $location
 * @param $timeout
 * @param $q
 * @param { Moment & function(): Moment} moment
 * @param jobService
 * @param modalService
 * @param FlashService
 * @return {JobListController}
 * @constructor
 */
class JobListController {
  /**
   * @param $scope
   * @param $location
   * @param $timeout
   * @param $q
   * @param moment
   * @param jobService
   * @param modalService
   * @param {FlashService} FlashService
   */
  constructor($scope, $location, $timeout, $q, moment, jobService, modalService, FlashService) {
    // noinspection BadExpressionStatementJS
    'ngInject';

    this.$scope = $scope;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$q = $q;
    this.moment = moment;
    this.jobService = jobService;
    this.modalService = modalService;
    this.flashService = FlashService;
    this.jobs = $scope.jobListVm.jobs;
    const hasJobsToday = this.jobs.some((job) => job.isToday);
    /**
     * @type {string}
     */
    this.jobFilter = hasJobsToday ? hasJobsToday.toString() : '';
    /**
     * @type {boolean}
     */
    this.updateInProgress = false;
  }

  /**
   * @param {Job} job
   */
  recordJobAttempt(job) {
    const modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Yes',
      headerText: 'Record Job Attempt',
      bodyText: `You arrived <span class="h5 bold">${job.address}</span> for
            <span class="h5 bold">
            ${job.title} ${this.moment(job.arrived).calendar()}</span>. Do you want to proceed to record details?`
    };

    this.updateStarted(job)
      .then(() => this.modalService.showModal({}, modalOptions)
        .then(() => this.$location.path('/jobs/' + job.id + '/complete'))
        .catch(() => this.updateComplete(job))
      )
      .catch(() => this.updateComplete(job));
  }

  /**
   * @param address {string}
   * @return {string}
   */
  getDirectionsUrl(address) {
    const replacedAddress = address.replace(/\n/g, ' ');
    return `https://maps.google.com?daddr=${replacedAddress}`;
  }

  /**
   }
   * @param {Job} job
   */
  arrivedJob(job) {
    if (job.arrived) {
      this.recordJobAttempt(job);
      return;
    }

    this.updateStarted(job)
      .then(() => this.modalService.showModal({}, {
        closeButtonText: 'Cancel',
        actionButtonText: 'Yes',
        headerText: 'Record Arrival',
        bodyText: `Are you sure you want to record arrival at
<span class="h5 bold">${job.address}</span> for
<span class="h5 bold">${job.title}?</span>`
      })
        .then(() =>
          this.jobService.arrivedJob(job.id)
            .then(
              /**
               * @param {JobArrival} response
               */
              (response) => {
                /**
                 * @type Moment
                 */
                const arrivedMoment = this.moment(response.arrived);
                job.arrived = arrivedMoment.format();
                this.flashService.Success('Arrival recorded');
              })
            .catch(() => this.flashService.Error('Recording arrival failed')))
        .then(() => this.$location.path('/jobs/' + job.id + '/complete'))
        .finally(() => this.updateComplete(job)));
  }

  /**
   * @param {Job} job
   * @return {boolean}
   */
  canUpdateStatus(job) {
    return !job.completed;
  }

  /**
   * @param {Job} job
   * @return {boolean}
   */
  updateStatusDisabled(job) {
    return !this.canUpdateStatus(job);
  }

  /**
   * @param {Job} job
   * @return Promise.<Job>
   */
  updateStarted(job) {
    job.updating();
    this.updateInProgress = true;
    return this.$q.resolve(job);
  }

  /**
   * @param {Job} job
   */
  updateComplete(job) {
    this.$timeout(() => {
      this.updateInProgress = false;
      job.updated();
    }, 1000);
  }
}

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:gfListJobs
 * @description
 * # gfJobList
 */
const JobListDirective = () => ({
  templateUrl: '/views/job-list.html',
  restrict: 'E',
  link: function (scope, element, attrs) {
    // element.text('this is the gfListJobs directive');
  },
  scope: {
    jobs: '='
  },
  controller: JobListController,
  controllerAs: 'jobListVm',
  bindToController: true
});


angular.module('gfcmsApp').directive('gfJobList', JobListDirective);
